const REQUIRED_VARS = ['VITE_API_URL'] as const

export function assertRequiredEnvVars(): void {
    const missing = REQUIRED_VARS.filter((key) => !import.meta.env[key])
    if (missing.length === 0) return

    const message = [
        `[Boot] Required environment variables are missing: ${missing.join(', ')}.`,
        ``,
        `Local dev: run \`cp .env.example .env\` in this module's directory (see README).`,
        `Builds: ensure the --mode flag selects an .env.<mode> file containing these variables.`,
    ].join('\n')

    throw new Error(message)
}
